import { useMemo } from 'react'
import {
  Dropdown,
  Search,
} from '@groovehq/internal-design-system/lib/components'
import { styles } from './styles'
import ProductItem from './ProductItem'

const { Menu } = Dropdown

const menu = list => {
  return (
    <Menu css={styles.menu}>
      {list.map(product => (
        <Menu.Item key={product.sku} itemKey={product.sku}>
          <ProductItem product={product} />
        </Menu.Item>
      ))}
    </Menu>
  )
}

const ProductsSearch = ({ className }) => {
  const onAddItem = () => {
    // TODO
  }
  const handleChange = () => {
    // TODO
  }
  const searchResults = []
  const overlay = useMemo(() => menu(searchResults), [searchResults])

  return (
    <div className={className} css={styles.base}>
      <Dropdown overlay={overlay} onSelect={onAddItem}>
        <Search
          onChange={handleChange}
          css={styles.search}
          placeholder="Search products…"
        />
      </Dropdown>
    </div>
  )
}

export default ProductsSearch
